import { Button } from "react-bootstrap";
import { FaFileExcel } from "react-icons/fa";
import { formatToSpanishTimeZone } from "../../utils/formatDate";
import ExcelJS from "exceljs";

const DownloadExelButton = ({
  incidentDataOnly,
  fieldsToShow,
  columnHeaders,
}) => {
  const excelClick = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("IncidentData");

    worksheet.columns = fieldsToShow.map((field, index) => ({
      header: columnHeaders[index],
      key: field,
    }));

    incidentDataOnly.forEach((data) => {
      const rowData = {};
      fieldsToShow.forEach((field) => {
        rowData[field] = data[field];
      });
      worksheet.addRow(rowData);
    });

    // Apply center alignment to all cells
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });
    });

    // Make headers bold
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.border = {
        bottom: { style: "thin", color: { argb: "000000" } }
      };
    });

    // Adjust column width to fit content
    worksheet.columns.forEach((column) => {
      let maxColumnLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        let columnLength = cell.text.length;
        if (columnLength > maxColumnLength) {
          maxColumnLength = columnLength;
        }
      });
      column.width = maxColumnLength + 4; // adding a little extra space
    });

    // Set autofilter for all columns
    const lastRowNumber = worksheet.lastRow.number;
    worksheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: lastRowNumber, column: fieldsToShow.length },
    };

    await workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Casos.xlsx";
      link.click();
    });
  };

  return (
    <div>
      <Button
        className="mb-3 mt-3 new-button excel-button custom-shadow-bold custom-bg-primary"
        onClick={excelClick}
      >
        <FaFileExcel size={20} /> <span className="new-button-text ps-0"></span>
      </Button>
    </div>
  );
};

export default DownloadExelButton;
